// Installable app: registers the service worker (web/public/sw.js) in production builds only.
// The worker is registered only when the server really serves it as JavaScript, so a server that
// answers /sw.js with the app's HTML (an SPA fallback) never produces a failed registration.

export interface RegistrationEnv {
  production: boolean;
  hasServiceWorker: boolean;
  /** https, or localhost (browsers treat it as secure). */
  secureContext: boolean;
}

export function shouldRegister(env: RegistrationEnv): boolean {
  return env.production && env.hasServiceWorker && env.secureContext;
}

export function isWorkerScript(status: number, contentType: string | null): boolean {
  return status >= 200 && status < 300 && /javascript/i.test(contentType ?? "");
}

export const SERVICE_WORKER_URL = "/sw.js";

export async function registerServiceWorker(): Promise<void> {
  const env: RegistrationEnv = {
    production: Boolean(import.meta.env.PROD),
    hasServiceWorker: typeof navigator === "object" && "serviceWorker" in navigator,
    secureContext: typeof window === "object" && window.isSecureContext,
  };
  if (!shouldRegister(env)) return;
  try {
    const probe = await fetch(SERVICE_WORKER_URL, { cache: "no-store" });
    if (!isWorkerScript(probe.status, probe.headers.get("content-type"))) return;
    await navigator.serviceWorker.register(SERVICE_WORKER_URL, { scope: "/" });
  } catch {
    // Offline or refused: the app works the same without it.
  }
}
